import { createContext, useContext, useState, useCallback } from "react";

interface StickyHeaderContextValue {
  stickyHeaderActive: boolean;
  setStickyHeaderActive: (active: boolean) => void;
}

const StickyHeaderCtx = createContext<StickyHeaderContextValue>({
  stickyHeaderActive: false,
  setStickyHeaderActive: () => {},
});

export function StickyHeaderProvider({ children }: { children: React.ReactNode }) {
  const [stickyHeaderActive, setStickyHeaderActiveRaw] = useState(false);
  const setStickyHeaderActive = useCallback((active: boolean) => {
    setStickyHeaderActiveRaw(active);
  }, []);

  return (
    <StickyHeaderCtx.Provider value={{ stickyHeaderActive, setStickyHeaderActive }}>
      {children}
    </StickyHeaderCtx.Provider>
  );
}

export function useStickyHeader() {
  return useContext(StickyHeaderCtx);
}
